import ReactDOM from 'react-dom';
import './Toast.scss';

const Toast = ({ message, type }) => {
  if (!message) return null;

  return ReactDOM.createPortal(
    <div className={`toast toast-${type}`}>
      {message}
    </div>,
    document.body
  );
};

export default Toast;
